
class SliderComponent extends HTMLElement {

    constructor (){

        super();

        this.enableSliderLooping = false;

        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.slider = this.querySelector('[id^="Slider-"]');

        if( ! this.slider )
            throw `Slider is missing its body`

        if( ! this.sliderItems.length  )
            throw `Slider is missing its slides`


        this.initPages();
        const resizeObserver = new ResizeObserver(() => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton?.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton?.addEventListener('click', this.onButtonClick.bind(this));

        document.addEventListener('Slider:Change',( event ) => {

            if( event.defaultPrevented )
                return

            if( event.target !== this )
                return

            this.scroll()
        })
    }

    get #sliderWidth (){
        return this.slider.clientWidth
    }

    get #sliderOffset (){
        return this.slider.scrollLeft
    }

    scroll (){
        this.slider.scrollTo({ left : this.left })
    }

    initPages (){

        this.sliderItemsToShow = Array
            .from(this.sliderItems)
            .filter(( element ) => element.clientWidth > 0 )

        if( this.sliderItemsToShow.length < 2 )
            return

        this.slideOffset =
            this.sliderItemsToShow[1].offsetLeft -
            this.sliderItemsToShow[0].offsetLeft

        this.slidesPerPage = Math.round(
            (   this.#sliderWidth -
                this.sliderItemsToShow[0].offsetLeft
            ) / this.slideOffset
        )

        this.totalPages =
            this.sliderItemsToShow.length -
            this.slidesPerPage + 1

        this.update()
    }

    resetPages (){
        this.sliderItems = this.querySelectorAll(`[ id ^= 'Slide-' ]`)
        this.initPages()
    }

    update (){

        const previousPage = this.currentPage;

        const progress = this.slider.scrollLeft / this.slideOffset

        this.currentPage = Math.round(progress) + 1;

        const section = this.closest('section')

        if( section ){
            section.style.setProperty(`---Progress`,progress.toFixed(2))
            section.style.setProperty(`---Slide`,String(this.currentPage))
        }

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }}));
        }

        if (this.enableSliderLooping) return;

        if( this.isAtStart )
            this.prevButton?.setAttribute('disabled','disabled')
        else
            this.prevButton?.removeAttribute('disabled')

        if( this.isAtEnd )
            this.nextButton?.setAttribute('disabled','disabled')
        else
            this.nextButton?.removeAttribute('disabled')
    }

    get isAtStart (){
        return this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0
    }

    get isAtEnd (){
        return this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])
    }

    isSlideVisible ( element , offset = 0 ){

        const windowEnd =
            this.#sliderWidth +
            this.#sliderOffset -
            offset

        const
            rightSide = ( element.offsetLeft + element.clientWidth ) ,
            leftSide = element.offsetLeft

        const buffer = 5 ;

        return ( rightSide - buffer ) <= windowEnd
            && ( leftSide + buffer ) >= this.#sliderOffset
    }

    onButtonClick ( event ){

        event.preventDefault()

        const step = event.currentTarget.dataset.step || 1


        this.left = this.slideScrollPosition = ( event.currentTarget.name === 'next' )
            ? this.slider.scrollLeft + ( step * this.slideOffset )
            : this.slider.scrollLeft - ( step * this.slideOffset )

        this.dispatchEvent(new CustomEvent('Slider:Change',{
            cancelable : true ,
            bubbles : true
        }))
    }
}

customElements.define('slider-component', SliderComponent);
